import React, { useEffect, useState } from "react";
import { Button, Container, Col, Form, Nav, Row, Image, Spinner ,Modal } from "react-bootstrap";
import { useNavigate, NavLink } from "react-router-dom";
import trash from "../../../assets/images/icons/trash.svg";
import edit from "../../../assets/images/icons/edit.svg"
import { useFormik } from "formik";
import * as Yup from "yup";
import {
  coachAddEducation,
  coachDeleteEducation,
} from "../../../utils/api";
import { useUserContext } from "../../../utils/hooks/UserContext";
import { toast } from "react-toastify";
import Loader from "../../../Loader/Loader";
import moment from 'moment'
const initialValuesEdu = {
  course: "",
  university_colleage: "",
};

const educationSchema = Yup.object().shape({
  course: Yup.string().required("Course is required").max(150),
  university_colleage: Yup.string().required("University/College is required").max(150),
});

const MAX_FILE_SIZE = 5242880; //100KB

const validFileExtensions = {
  image: ["jpg", "gif", "png", "jpeg", "svg", "webp"],
};

function isValidFileType(fileName, fileType) {
  return (
    fileName &&
    validFileExtensions[fileType].indexOf(fileName.split(".").pop()) > -1
  );
}


const EditProfileEducation = (props) => {
  const [educations, seteducations] = useState([]);
    const navigate = useNavigate();
    const { getUserFromToken, user } = useUserContext();
    // State to track if editing
    const [editingEducation, setEditingEducation] = useState(false);
    const [visible, setVisible] = useState(false);
    const [isSave, setSaved] = useState(false);

    const [deleteId, setDeleteId] = useState("");
    const [allYears, setAllYears] = useState([]);
    const [isSubmitting, setisSubmitting] = useState(false);
    
    const [mode, setMode] = useState(null); // "education" or "experience"
  
    useEffect(() => {
      const canonicalUrl = `${window.location.origin}${window.location.pathname}`;
      let link = document.querySelector("link[rel='canonical']");
      if (!link) {
        link = document.createElement("link");
        link.setAttribute("rel", "canonical");
        document.head.appendChild(link);
      }
      link.setAttribute("href", canonicalUrl);
  
      seteducations(user?.educations);
    }, [user]);
  
    const onClickSave = async (values) => {
      try {
  
        setisSubmitting(true);
        let test = false;
        const newEducation = educations?.filter((i) => i?.status === "new");
        for (let index = 0; index < newEducation?.length; index++) {
          const element = newEducation[index];
          const formData = new FormData();
          formData.append("course", element?.course);
          formData.append("university_colleage", element?.university_colleage);
          if(element?.passing_year != undefined){
            formData.append("passing_year", moment().format('YYYY-MM-DD'));
          }
          let data = await coachAddEducation(formData);
          test = data.data?.status;
        }
  
        const deletedEducation = educations?.filter(
          (i) => i?.status === "deleted"
        );
  
        if (deletedEducation?.length > 0) {
          const formData = new FormData();
          formData.append(
            "education_ids",
            `[${deletedEducation?.map((i) => i?.id)}]`
          );
  
          let data = await coachDeleteEducation(formData);
          test = data.data?.status;
        }
  
        if(test){
          setSaved(false)
          toast.success("Education updated successfully!");
        }
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message);
      } finally {
        getUserFromToken();
        
        setisSubmitting(false);
        navigate("/coach/profile");
      }
    };
  
    const handleSubmitEducation = (values, { resetForm }) => {
      formikEdu.setValues({
        ...formikEdu.values,
        course: "",
        university_colleage: "",
        passing_year: "",
      });
      setSaved(true)
      seteducations([
        ...educations,
        {
          id: new Date()?.getTime(),
          course: values?.course,
          university_colleage: values?.university_colleage,
          status: "new",
          passing_year: values.passing_year,
        },
      ]);
      resetForm();
    };
  
    const formikEdu = useFormik({
      initialValues: initialValuesEdu,
      validationSchema: educationSchema,
      onSubmit: handleSubmitEducation,
    });
  
  
    const onRemoveEducation = (id) => {
      const results = JSON.parse(JSON.stringify(educations))?.map((i) => {
        if (id === i?.id) {
          i.status = "deleted";
        }
        return i;
      });
      seteducations(results);
      setVisible(false);
    };

    const handleDelete = (id, delete_type) => {
      if (delete_type === "education") {
        setDeleteId(id);
        setVisible(true);
        onRemoveEducation(id)
      }
    };

  return (
    <>
    <Modal size="lg" {...props} aria-labelledby="contained-modal-title-vcenter" centered>
      <div className="profile_edit_forms my_light_modal">
          <Container>
            <Row className='g-3'>
              <Col lg="12">
                <Form className="profile_edit_forms mt-4 px-3 py-2" onSubmit={formikEdu.handleSubmit}
                >
                <Col sm="12" className="mb-4">
                  <Form.Label className="title">Education</Form.Label>

                  {/* Existing Education List */}
                  {educations
                    ?.filter((i) => i?.status !== "deleted")
                    ?.map((education) => (
                      <Row key={education.id}>
                        <Col className="col-12 mx-auto">
                          <div className="pr_dtls_prvw">
                            <div>
                              <p className="fs-16 fw-500 text_brand_color4 m-0">
                                {education.course}
                              </p>
                              <small className="d-block fs-14 fw-400 text_brand_color4">
                                {education.university_colleage}
                              </small>
                            </div>
                            <div className="d-flex align-items-center">
                              <Button
                                className="p-0 m-2"
                                variant=""
                                onClick={() => handleDelete(education?.id, "education")}
                              >
                                <Image src={trash} />
                              </Button>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    ))}

                  {/* Education Form Fields */}
                  <Row className="d-flex justify-content-end">
                    <Col className={
                        window.innerWidth < 500
                          ? "col-auto w-100 mt-3"
                          : "col-auto input-width mt-3" }>
                      <Form.Group as={Col}>
                        <Form.Control
                          type="text"
                          placeholder="Course"
                          name="course"
                          value={formikEdu.values.course}
                          onChange={formikEdu.handleChange}
                          isInvalid={
                            formikEdu?.touched?.course && !!formikEdu?.errors?.course
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikEdu?.errors?.course}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col className="mt-3 input-width">
                      <Form.Group as={Col}>
                        <Form.Control
                          type="text"
                          placeholder="University/College"
                          name="university_colleage"
                          value={formikEdu.values.university_colleage}
                          onChange={formikEdu.handleChange}
                          isInvalid={
                            formikEdu?.touched?.university_colleage &&
                            !!formikEdu?.errors?.university_colleage
                          }
                        />
                        <Form.Control.Feedback type="invalid">
                          {formikEdu?.errors?.university_colleage}
                        </Form.Control.Feedback>
                      </Form.Group>
                    </Col>
                    <Col className="col-auto mt-3">
                      <Button type="submit" variant="success" className="px-4"
                      disabled={!formikEdu.values.course || !formikEdu.values.university_colleage}
                      >
                        {editingEducation ? "Update" : "Add"}
                      </Button>
                    </Col>
                  </Row>
                </Col>
                </Form>
              </Col>
            </Row>
            <Row className='justify-content-end mt-4'>
              <Col sm="auto">
                  <Button variant='success' className='px-5' disabled={!isSave} onClick={isSave ? onClickSave : undefined}>Save</Button>
              </Col>
            </Row>
          </Container>

      </div>
    </Modal>
    </>
  );
}

export default EditProfileEducation;